<template>
  <div class="redir-overlay" role="status" aria-live="polite">
    <div class="redir-card">
      <div class="redir-spinner" aria-hidden="true">
        <div class="redir-spinner__ring"></div>
      </div>
      <p class="redir-label">Redirecting you to</p>
      <h2 class="redir-name">{{ tenantName }}</h2>
      <p class="redir-sub">Please wait while we load your workspace…</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RedirectingOverlay',
  props: {
    tenantName: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.redir-overlay {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: var(--cc-backdrop);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.redir-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;
  width: 100%;
  max-width: 480px;
  background: var(--cc-card);
  backdrop-filter: blur(28px) saturate(150%);
  -webkit-backdrop-filter: blur(28px) saturate(150%);
  border: 1px solid var(--cc-card-border);
  border-top: 3px solid #0092bf;
  border-radius: 6px;
  padding: 3rem 2rem;
  box-shadow: var(--cc-card-shadow);
  transition: background 0.3s, border-color 0.3s, box-shadow 0.3s;
}

@media (min-width: 640px) {
  .redir-card {
    padding: 4rem 3rem;
  }
}

/* ── Spinner ───────────────────────────────────────── */
.redir-spinner {
  position: relative;
  width: 64px;
  height: 64px;
  margin-bottom: 0.5rem;
  flex-shrink: 0;
}

@media (min-width: 640px) {
  .redir-spinner {
    width: 80px;
    height: 80px;
  }
}

.redir-spinner__ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 3px solid rgba(0, 146, 191, 0.18);
  border-top-color: #0092bf;
  animation: redir-spin 0.8s linear infinite;
}

@keyframes redir-spin {
  to { transform: rotate(360deg); }
}

/* ── Text ──────────────────────────────────────────── */
.redir-label {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--cc-t3);
  margin: 0;
  transition: color 0.3s;
}

.redir-name {
  font-family: 'Big Shoulders Display', sans-serif;
  font-size: clamp(1.75rem, 5vw, 2.75rem);
  font-weight: 800;
  letter-spacing: 0.03em;
  color: var(--cc-t1);
  margin: 0;
  line-height: 1.1;
  transition: color 0.3s;
}

.redir-sub {
  font-size: 0.875rem;
  color: var(--cc-t3);
  margin: 0;
  transition: color 0.3s;
}
</style>
